'use strict';

export async function initGsap() {
  const {default: gsap} = await import('gsap');
  const {default: ScrollTrigger} = await import('gsap/ScrollTrigger');
  const {default: CustomEase} = await import('gsap/CustomEase');
  const {default: SplitText} = await import('gsap/SplitText');

  gsap.config({ trialWarn: false });

  gsap.registerPlugin(ScrollTrigger, CustomEase, SplitText);

  CustomEase.create('easeInOutQuint', '0.22, 1, 0.36, 1');
  CustomEase.create('customEase', '0.87, 0, 0.13, 1'); // @TODO update these values from design

  window.gsap = gsap;
  window.ScrollTrigger = ScrollTrigger;
  window.CustomEase = CustomEase;
  window.SplitText = SplitText;
}
